exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agreement_box[data-v-e51a2a9c]{width:100%;height:auto;padding:.6rem}.agreement_title[data-v-e51a2a9c]{width:100%;line-height:1.1rem;font-size:.8rem;color:#27282d;text-align:center;font-weight:700;margin-top:.2rem;margin-bottom:.2rem}.agreement_con[data-v-e51a2a9c]{width:100%;line-height:1rem;font-size:.7rem;color:#27282d;max-height:15.7rem;overflow-x:hidden;overflow-y:auto;padding-right:.2rem}.agreement_con p[data-v-e51a2a9c]{margin-bottom:.4rem}.agreement_bottom[data-v-e51a2a9c]{width:100%;padding:.5rem}.agreement_ts[data-v-e51a2a9c]{width:100%;line-height:1rem;font-size:.5rem;color:#666}", ""]);

// exports
